function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/* @indexer:no-export */
import React, { useRef, useMemo, useEffect, useState, forwardRef, useContext } from 'react';
import { createPortal } from 'react-dom';
import styles from './Tips.module.scss';
import I18n from '../../I18n/I18n/I18n';
import cs from 'classnames';
import { TOOLTIP_CONTAINER_ID } from '../TooltipContext';
import useWindowWidth from '../../hooks/useWindowWidth';
import useScrolling from '../../hooks/useScrolling';
import ThemeContext from '../../ThemeContext/ThemeContext';
var isVertical = function isVertical(dir) {
  return ['top', 'bottom'].includes(dir);
};
var confine = function confine(min, max, num) {
  return Math.max(min, Math.min(num, max));
};
function getHorizontal(_ref) {
  var top = _ref.top,
    left = _ref.left,
    width = _ref.width,
    height = _ref.height,
    tipWidth = _ref.tipWidth,
    tipHeight = _ref.tipHeight,
    arrowWidth = _ref.arrowWidth,
    arrowHeight = _ref.arrowHeight,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'right' : _ref$direction;
  var canGoRight = left + width + arrowWidth + tipWidth < window.innerWidth;
  var canGoLeft = left - arrowWidth - tipWidth > 0;
  var dir;
  if (direction === 'right') {
    dir = canGoRight ? 'right' : 'left';
  } else {
    dir = canGoLeft ? 'left' : 'right';
  }
  if (!canGoLeft && !canGoRight) {
    var _arguments$ = arguments[0],
      y = _arguments$.direction,
      rest = _objectWithoutProperties(_arguments$, ["direction"]);
    return getVertical(rest);
  }
  var topBase = top + window.pageYOffset;
  var arrowTop = topBase + (height / 2 - arrowHeight / 2);
  var textTop = confine(window.pageYOffset, window.pageYOffset + window.innerHeight - tipHeight + arrowHeight, topBase + (height / 2 - (tipHeight - arrowHeight) / 2));
  var leftBase = left + window.pageXOffset;
  if (dir === 'right') {
    var leftPosition = leftBase + width;
    return {
      calculated: true,
      dir: 'right',
      arrow: {
        top: arrowTop,
        left: leftPosition
      },
      text: {
        top: textTop,
        left: leftPosition + arrowWidth
      }
    };
  } else {
    var _leftPosition = leftBase - arrowWidth;
    return {
      calculated: true,
      dir: 'left',
      arrow: {
        top: arrowTop,
        left: _leftPosition
      },
      text: {
        top: textTop,
        left: _leftPosition - tipWidth
      }
    };
  }
}
function getVertical(_ref2) {
  var top = _ref2.top,
    left = _ref2.left,
    width = _ref2.width,
    height = _ref2.height,
    tipWidth = _ref2.tipWidth,
    tipHeight = _ref2.tipHeight,
    arrowWidth = _ref2.arrowWidth,
    arrowHeight = _ref2.arrowHeight,
    _ref2$direction = _ref2.direction,
    direction = _ref2$direction === void 0 ? 'bottom' : _ref2$direction;
  var bottom = top + height;
  var arrowLeft = left + window.pageXOffset + width / 2;
  var tipLeft = Math.max(0, arrowLeft - tipWidth / 2);
  var finalTipLeft = tipLeft + tipWidth > window.innerWidth ? window.innerWidth - tipWidth : tipLeft;
  var canGoBottom = bottom + tipHeight < window.innerHeight;
  var canGoTop = top - arrowHeight - tipHeight > 0;
  var dir;
  if (direction === 'top') {
    dir = canGoTop ? 'top' : 'bottom';
  } else {
    dir = canGoBottom || !canGoTop ? 'bottom' : 'top';
  }
  if (dir === 'top') {
    var topPosition = top + window.pageYOffset;
    return {
      calculated: true,
      dir: 'top',
      arrow: {
        top: topPosition - arrowHeight,
        left: arrowLeft
      },
      text: {
        top: topPosition - tipHeight,
        left: finalTipLeft
      }
    };
  } else {
    var _topPosition = window.pageYOffset + bottom;
    return {
      calculated: true,
      dir: 'bottom',
      arrow: {
        top: _topPosition,
        left: arrowLeft
      },
      text: {
        top: _topPosition + arrowHeight,
        left: finalTipLeft
      }
    };
  }
}
function getInitialState(direction) {
  return {
    calculated: false,
    dir: direction,
    arrow: {
      top: 0,
      left: 0
    },
    text: {
      top: 0,
      left: 0
    }
  };
}
function useTooltip(
// show is needed because we want useEffect to re-run when that changes!
show, direction, _ref3) {
  var positionRef = _ref3.positionRef,
    arrowRef = _ref3.arrowRef,
    textRef = _ref3.textRef;
  var _useState = useState(getInitialState(direction)),
    _useState2 = _slicedToArray(_useState, 2),
    styles = _useState2[0],
    setStyles = _useState2[1];
  var width = useWindowWidth();
  var _useScrolling = useScrolling({
      delay: 45,
      useThrottle: false
    }),
    _useScrolling2 = _slicedToArray(_useScrolling, 2),
    scrollY = _useScrolling2[1];
  useEffect(function () {
    var arrow = arrowRef.current;
    var tip = textRef.current;
    var el = positionRef.current;
    if (tip && arrow) {
      var _arrow$getBoundingCli = arrow.getBoundingClientRect(),
        arrowWidth = _arrow$getBoundingCli.width,
        arrowHeight = _arrow$getBoundingCli.height;
      var _tip$getBoundingClien = tip.getBoundingClientRect(),
        tipWidth = _tip$getBoundingClien.width,
        textHeight = _tip$getBoundingClien.height;
      var tipHeight = arrowHeight + textHeight;
      if (el) {
        var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          left = _el$getBoundingClient.left,
          _width = _el$getBoundingClient.width,
          height = _el$getBoundingClient.height;
        var func = isVertical(direction) ? getVertical : getHorizontal;
        var _styles = func({
          top: top,
          left: left,
          width: _width,
          height: height,
          tipWidth: tipWidth,
          tipHeight: tipHeight,
          arrowWidth: arrowWidth,
          arrowHeight: arrowHeight,
          direction: direction
        });
        setStyles(_styles);
      }
    }
    return function () {
      setStyles(getInitialState(styles.dir));
    };
  }, [arrowRef, direction, positionRef, textRef, show, styles.dir, width, scrollY]);
  return styles;
}
function Tooltip(_ref4) {
  var triggerRef = _ref4.triggerRef,
    id = _ref4.id,
    show = _ref4.show,
    type = _ref4.type,
    direction = _ref4.direction,
    children = _ref4.children,
    forwardedRef = _ref4.forwardedRef,
    onMouseOut = _ref4.onMouseOut,
    Component = _ref4.Component,
    className = _ref4.className;
  var arrowRef = useRef(null);
  var textRef = useRef(null);
  var theme = useContext(ThemeContext);
  var _useTooltip = useTooltip(show, direction, {
      positionRef: triggerRef,
      arrowRef: arrowRef,
      textRef: textRef
    }),
    dir = _useTooltip.dir,
    calculated = _useTooltip.calculated,
    arrow = _useTooltip.arrow,
    text = _useTooltip.text;
  var style = useMemo(function () {
    return {
      visibility: calculated ? 'visible' : 'hidden'
    };
  }, [calculated]);
  var portalEl = document.getElementById(TOOLTIP_CONTAINER_ID) || document.body;
  if (show) {
    return createPortal(/*#__PURE__*/React.createElement("span", {
      ref: forwardedRef,
      className: cs(styles.tip, styles[type], styles[theme], _defineProperty({}, className || '', className))
      // @ts-ignore
      ,
      style: style,
      onMouseOut: onMouseOut
    }, /*#__PURE__*/React.createElement("span", {
      ref: arrowRef,
      style: arrow,
      className: cs(styles.arrow, styles[dir], '_dm-tooltip__arrow')
    }), /*#__PURE__*/React.createElement("span", {
      ref: textRef,
      id: id,
      role: "status",
      className: cs(styles.text, '_dm-tooltip__content', "auto-t-tip", "auto-".concat(type), "auto-".concat(id)),
      style: text
    }, Component ? /*#__PURE__*/React.createElement(Component, null, children) : /*#__PURE__*/React.createElement(I18n, {
      i18n: children
    }))), portalEl);
  } else {
    return null;
  }
}
export default forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Tooltip, Object.assign({}, props, {
    forwardedRef: ref
  }));
});